import React from "react";
import styles from "../Submenu.module.css";

interface SubmenuGridProps {
  children: React.ReactNode;
  columns: number;
  departmentName?: string;
}

const SubmenuGrid = ({
  children,
  columns,
  departmentName,
}: SubmenuGridProps) => {
  // Ensure a minimum of 6 columns
  const minColumns = 6;
  const gridColumns = Math.max(columns, minColumns);

  const gridStyle: React.CSSProperties = {
    gridTemplateColumns: `repeat(${gridColumns}, minmax(0, 1fr))`,
  };

  return (
    <ul
      style={gridStyle}
      aria-label={departmentName}
      className={`${styles.submenu__grid} submenu__grid`}
    >
      {children}
    </ul>
  );
};

export default SubmenuGrid;
